export const Playlist = {
    featuredPlaylist: 'featured-playlist',
    personalPlaylist: 'personal-playlist',
    studioPlaylist: 'studio-playlist',
    FPL: 'FPL',
    PPL: 'PPL',
    SPL: 'SPL',
    ALL: 'all'
}